<template>
  <div class="global-loader">
    <div class="global-loader-mask"></div>
    <div class="global-loader-animation"></div>
  </div>
</template>

<script>
export default {
  name: "GlobalLoader",
  components: {},
  props: {
    value: Number
  },
  data() {
    return {
      data: {}
    };
  },
  mounted() {},
  methods: {
    back() {
      //service.send("continue");
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.global-loader {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.global-loader-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  opacity: 0.6;
  z-index: 1;
}
.global-loader-animation {
  width: 100%;
  height: 100%;
  margin: auto;
  background-image: url("../assets/images/spinner.gif");
  background-size: 200px;
  background-repeat: no-repeat;
  position: absolute;
  background-position: center;
  z-index: 2;
}
</style>
